var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"添加专家信息","visible":_vm.editVisible,"maskClosable":false,"width":"80vw","centered":"","destroyOnClose":"","footer":null},on:{"cancel":function($event){_vm.editVisible=false}}},[_c('expert-form',{ref:"addForm",on:{"success":_vm.addSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }